import React, { useState } from "react";
import InteriorImage from "../../components/gallery/InteriorImage";
import ExteriorImage from "../../components/gallery/ExteriorImage";
import ViewImage from "../../components/gallery/ViewImage";

const Gallery = () => {
    const [interiorImageLoading, setInteriorImageLoading] = useState(false);
    const [showInterior, setShowInterior] = useState(false);
    const [showViewImage, setShowViewImage] = useState(false);
    const [imageCaraousel, setImageCaraousel] = useState(false)

    return (
        <div className="gallerySection">
            {!interiorImageLoading || !imageCaraousel ? (
                <div
                    className="row justify-content-evenly align-items-center"
                    style={{ height: "100%", width: "100%" }}
                >
                    <div className="col-4 pe-0">
                        <div className="exteriorImageSection"
                            onClick={() => {
                                setInteriorImageLoading(true);
                                setShowInterior(false);
                                setShowViewImage(false);
                                setImageCaraousel(true);
                            }}
                        >
                            <h3 className="interiorHeading"  >
                                Exterior
                            </h3>
                        </div>
                    </div>
                    <div className="col-4 ps-0">
                        <div className="interiorImageSection"
                            onClick={() => {
                                setInteriorImageLoading(true);
                                setShowInterior(true);
                                setShowViewImage(false);
                                setImageCaraousel(true);
                            }}
                        >
                            <h3 className="interiorHeading">
                                Interior
                            </h3>
                        </div>
                    </div>
                </div>
            ) : (
                showInterior ?
                    <InteriorImage
                        setImageCaraousel={setImageCaraousel}
                        imageCaraousel={imageCaraousel}
                    /> :
                    <ExteriorImage
                        setImageCaraousel={setImageCaraousel}
                        imageCaraousel={imageCaraousel}
                    />
            )}
        </div>
    );
};

export default Gallery;